import { useMemo } from 'react'
import { SalesTeamOption } from '@user/components/Dashboard/widgets/hooks'
import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'
import { salesTeamsForCurrentUser } from '@user/store/salesTeam'

export function useData() {
  const salesTeams = useSelector(salesTeamsForCurrentUser)

  const { values } = useFormikContext<{
    salesTeamIds: number[]
  }>()

  const options = useMemo(
    () =>
      [...salesTeams].map((team) => ({
        id: team.id,
        label: team.name,
        branchName: team.branchName,
        name: team.name,
      })),
    [salesTeams],
  )

  const value = useMemo(() => {
    if (!values.salesTeamIds) return []

    return [...options].filter((team: SalesTeamOption) =>
      values.salesTeamIds.includes(team.id),
    )
  }, [options, values])

  return {
    value,
    options,
  }
}
